export default "__VITE_ASSET__CQoXW_3n__"